import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import type { SvgIconTypeMap } from "@mui/material";
import type { OverridableComponent } from "@mui/types";

export const iconByColorMode: Record<
  "light" | "dark",
  OverridableComponent<SvgIconTypeMap> & {
    muiName: string;
  }
> = {
  light: DarkModeIcon,
  dark: LightModeIcon,
};

export const labelByColorMode: Record<"light" | "dark", string> = {
  light: "Switch to dark mode",
  dark: "Switch to light mode",
};
